import styled from "styled-components";
import { colors } from "sweet-web/lib/styles";

export const Title = styled.h1`
  font-size: 24px;
  font-weight: 700;
  color: ${colors.nearBlack};
  margin: 5px 0;
`;

export const SectionTitle = styled.h2`
  font-size: 17px;
  font-weight: 600;
  color: ${colors.nearBlack};
  margin-bottom: 20px;
`;

export const SectionLabel = styled.h3`
  font-size: 14px;
  font-weight: 600;
  color: ${colors.nearBlack};
  margin-bottom: 5px;
`;

export const Label = styled.p`
  font-size: 14px;
  font-weight: 500;
  color: ${colors.gray};
`;

export const Badge = styled.span<{ color?: string; textColor?: string }>`
  display: block;
  padding: 3px 5px;
  background-color: ${props => (props.color ? props.color : colors.primary)};
  font-size: 12px;
  font-weight: 600;
  color: ${props => (props.textColor ? props.textColor : colors.white)};
  border-radius: 5px;
`;

export const ItemTitle = styled.h3`
  font-size: 14px;
  font-weight: 600;
  color: ${colors.nearBlack};
  margin-bottom: 5px;
`;

export const ItemLabel = styled.p`
  font-size: 12px;
  font-weight: 500;
  color: ${colors.gray};
  margin-bottom: 10px;
`;

export const Paragraph = styled.p`
  font-size: 12px;
  font-weight: 500;
  color: ${colors.darkGray};
`;
